export const IMAGE_HOST_URL = "https://coda-farm-technologies.imgix.net"
export function buildSupportImageUrl(imageName: string) {
  return `${IMAGE_HOST_URL}/support/${imageName}`
}
